export default __webpack_public_path__ + "static/media/dollar.58825dec.svg";